import { render, staticRenderFns } from "./nextInfo.vue?vue&type=template&id=56502c70&scoped=true&"
import script from "./nextInfo.vue?vue&type=script&lang=js&"
export * from "./nextInfo.vue?vue&type=script&lang=js&"
import style0 from "./nextInfo.vue?vue&type=style&index=0&id=56502c70&scoped=true&lang=css&"
import style1 from "./nextInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56502c70",
  null
  
)

export default component.exports